import { Helmet } from 'react-helmet-async';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import { Stack, Container, Typography } from '@mui/material';

export default function Approval() {
  return (
    <>
      <Helmet>
        <title> About | SMARTSHIELD </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            About
          </Typography>
        </Stack>
        <VerticalTimeline layout="1-column-left" lineColor="black">
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            position="right"
            contentStyle={{ background: 'white', color: '#000', border: '2px solid #ccc' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="October 2025"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title">V2.1.4</h3>
            <h4 className="vertical-timeline-element-subtitle">SMARTSHIELD</h4>
            <p>
              • Increase security improvement
              <br />
              • Implemented a function for sending email notification alerts. <br />
              • Added and updated filenames across the dataset, alert details, and alert list views for improved
              clarity. <br />
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            position="right"
            contentStyle={{ background: 'white', color: '#000', border: '2px solid #ccc' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="October 2025"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title">V2.1.3</h3>
            <h4 className="vertical-timeline-element-subtitle">SMARTSHIELD</h4>
            <p>
              • Addressed cache management issues for document display <br />
              • Improved UI on View Document dataset map <br />
              • Improved performance by reducing thumbnail size <br />
              • Added ability to assign DataViewer role to internal users <br />
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            position="right"
            contentStyle={{ background: 'white', color: '#000', border: '2px solid #ccc' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="February 2025"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title">V2.1.2</h3>
            <h4 className="vertical-timeline-element-subtitle">SMARTSHIELD</h4>
            <p>
              • Remove column created_at and updated_by on report <br />
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            position="right"
            contentStyle={{ background: 'white', color: '#000', border: '2px solid #ccc' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="February 2025"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title">V2.1.1</h3>
            <h4 className="vertical-timeline-element-subtitle">SMARTSHIELD</h4>
            <p>
              • Fixed the tickbox bug when customizing the Dataviewer dataset permissions. <br />
              • Added the auto disable inactive user if user does not online for 60 days. <br />
              • Fixed the internal API bug when multiple alert events coming. <br />
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            position="right"
            contentStyle={{ background: 'white', color: '#000', border: '2px solid #ccc' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="September 2024"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title">V2.1.0</h3>
            <h4 className="vertical-timeline-element-subtitle">SMARTSHIELD</h4>
            <p>
              • Restrict login to 1 session per user <br />
              • Added LDAP support for user login. <br />
              • Fix alert processing where authorized change preserve unauthorized change <br />
              • Parametrize user implementation variable.
              <br />
              • User Experience enhancement <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Optimization on Dataset Map menu navigation <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Optimization on Alert Processing function menu. <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ UI button will be disabled after pressed to avoid multi queing by
              accident. <br />
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            position="right"
            contentStyle={{ background: 'white', color: '#000', border: '2px solid #ccc' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="August 2024"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title">V2.0</h3>
            <h4 className="vertical-timeline-element-subtitle">SMARTSHIELD</h4>
            <p>
              • Added Feature document can be verify via web with API <br />
              • Added Reporting for Verify via web API. <br />
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            position="right"
            contentStyle={{ background: 'white', color: '#000', border: '2px solid #ccc' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="July 2024"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          >
            <h3 className="vertical-timeline-element-title">V1.1.0</h3>
            <h4 className="vertical-timeline-element-subtitle">SMARTSHIELD</h4>
            <p>
              • New user type – Dataset Viewer to allow view only access to specifically authorized data records. <br />
              • Optimized Dataset Map page loading. <br />
              • Dataset Map search bar. <br />
              • “About” screen to display version log of SMARTSHIELD versions, releases, and patches. <br />• Fixed for
              duplicate alert scenario where a duplicate alert is created when an unauthorized change is detected for a
              record that already has an alert in pending approval or pending rollback. Fix ensures duplicate is not
              created and the alert is changed back to in progress. <br />• Fixed alert display for authorized change
              with unauthorized changes detected where record before is equal to record after.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            position="right"
            contentStyle={{ background: 'white', color: '#000', border: '2px solid #ccc' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="May 2024"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff', borderRadius: '50%' }}
          >
            <h3 className="vertical-timeline-element-title">V1.0.0</h3>
            <h4 className="vertical-timeline-element-subtitle">SMARTSHIELD</h4>
            <p>
              • SMARTSHIELD Data Integrity Engine to perform data integrity checking for data records and transaction
              records when ever a record is updated or deleted, or a record is verified from the dataset map.
              <br />
              • Blockchain technology stack for the storage of verifiable proof of data records or transaction records.
              <br />
              • Transmitter API to receive new records or updates to records to store on the blockchain. <br />
              • Listener processing that sends verification requests to the client system via Listener API to retrieve
              records for verification. <br />
              • Web based utility for adding datasets and dataset map hierarchy rules on SMARTSHIELD. <br />
              • SMARTSHIELD Web based User Interface which provides access to the following functions: <br />
              &nbsp;&nbsp;&nbsp; ◦ Executive Dashboard (including Active alert status, Dashboard Charts, Calendar &
              Verification Schedule, and SMARTSHIELD Function Menu). <br />
              &nbsp;&nbsp;&nbsp; ◦ Dataset Map to navigate the monitored data with support for multiple
              <br />
              datasets and to view record details. <br />
              &nbsp;&nbsp;&nbsp; ◦ Verification Scheduler via Dataset Map menu <br />
              &nbsp;&nbsp;&nbsp; ◦ Alert Processing Function for alerts. <br />
              &nbsp;&nbsp;&nbsp; ◦ Calendar menu to view and manage scheduled dataset record verifications. <br />
              &nbsp;&nbsp;&nbsp; ◦ Reporting menu to generate reports by selecting the time period for execution and
              exported as .csv spreadsheet. <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Active Alerts – Open <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Active Alerts – In Progress <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Active Alerts – Pending Approval <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Active Alerts – Pending Rollback <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Active Alerts – All <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Processed Alerts – Rolled Back <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Processed Alerts – Kept <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Processed Alerts – All <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Authorized Data Update <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ▪ Unauthorized Data Update <br />
              &nbsp;&nbsp;&nbsp; ◦ Action menu for building actions for alert processing. <br />
              &nbsp;&nbsp;&nbsp; ◦ User Management menu to for client management of SMARTSHIELD users Maker, Checker and
              Dataset Owner. <br />
              &nbsp;&nbsp;&nbsp; ◦ Information menu for easy access to links for client documentation.
              <br />
              &nbsp;&nbsp;&nbsp; ◦ Activity Log that tracks all activity in SMARTSHIELD.
              <br />
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </Container>
    </>
  );
}
